import React from 'react';
import { ProductLineType } from '@gql/schema';
import { InfoBox, InfoBoxVariant, Scale } from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useAppState } from '@utils/useAppState';
import { useServerState } from '@utils/useServerState';
import { useTranslations } from '@utils/useTranslations';
import { StyledInfoBox } from './OmnibusDirective.styles';

export const OmnibusDirective = () => {
  const { sale } = useServerState();
  const { translations } = useTranslations();
  const { finalRates } = useAppState();

  const consumerInformation = sale?.consumerInformation?.filter(Boolean) ?? [];

  if (consumerInformation.length === 0) {
    return null;
  }

  const selectedConsumerInfo = finalRates.flightsSelected
    ? consumerInformation.find(info => info?.type === ProductLineType.HotelPlus)
    : consumerInformation.find(info => info?.type === ProductLineType.HotelOnly);

  if (!selectedConsumerInfo?.text) {
    return null;
  }

  return (
    <StyledInfoBox>
      <InfoBox
        title={i18n('sale.omnibus.directive.title', [], translations)}
        subTitle={selectedConsumerInfo.text}
        variant={InfoBoxVariant.safety}
        borderConfig={{
          radius: Scale.xxs,
          showLeftLip: false,
        }}
        dataAttributes={{ testid: 'omnibus-directive' }}
      />
    </StyledInfoBox>
  );
};
